<template>
  <div
    class="flex flex-direction justify-center align-center"
    id="parallelSessions"
  >
    <div class="container">
      <div class="top">
        <Title :ch="'区域活动'" :bg-img="titleBgImg"> </Title>
      </div>
      <div class="content flex flex-direction justify-start">
        <div class="desc">
          承接“因聚而生
          为你所能”的理念，华为中国政企将联合行业客户、合作伙伴等多方力量，贯穿全年不间断为广大客户及伙伴推出各类特色区域活动，与伙伴携手成长，为客户创造新价值。您的参与，是我们最大的期待！
        </div>
        <div class="more-box" style="justify-self: end">
          <div class="more cs" @click="lookMore">
            <div class="text">查看详情</div>
            <img src="../assets/images/agenda/home/red-arrow.png" />
          </div>
          <!--          <div class="more">-->
          <!--            <div class="text">敬请期待</div>-->
          <!--          </div>-->
        </div>
      </div>
      <!--      <DidLink-->
      <!--        :isHave="true"-->
      <!--        :isSwiper="false"-->
      <!--        @click.native="lookMore"-->
      <!--      ></DidLink>-->
    </div>
  </div>
</template>

<script>
import Title from "./common/Title";
export default {
  name: "ParallelSessions",
  components: {
    Title,
  },
  data() {
    return {
      titleBgImg: require("../assets/images/wap/title/cityTravel.png"),
    };
  },
  methods: {
    lookMore() {
      window._hw("send", "action", "index_online_check_meeting_detial_click");
      this.$router.push({
        path: "/cityTravel",
      });
    },
  },
};
</script>

<style scoped lang="scss">
@media screen and (min-width: 992px) {
  #parallelSessions {
    display: block;
    width: 100vw;
    padding-top: 60px;
    padding-bottom: 60px;
    .container {
      .top {
        margin-left: 160px;
        width: 1600px;
        padding-bottom: 5px;
      }
      .content {
        width: 1600px;
        height: 560px;
        margin-left: 160px;
        padding: 120px 0 120px 60px;
        position: relative;
        background-image: url("../assets/images/parallelSessions/bg-pc.png");
        background-repeat: no-repeat;
        background-position: 0 0;
        background-size: 100% 100%;
        .second_title {
          font-size: 34px;
          font-family: Microsoft YaHei-Light;
          font-weight: 600;
          color: #151e26;
          height: 72px;
          line-height: 51px;
        }
        .desc {
          width: 600px;
          font-size: 18px;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;
          color: #151e26;
          text-align: justify;
          word-break: break-all;
          text-justify: distribute;
          line-height: 1.8;
        }
        .more-box {
          padding: 8px 14px 0 0px;
          position: absolute;
          bottom: 120px;
          //border: 1px solid #b4251e;
          .more {
            height: 24px;
            font-size: 18px;
            font-family: Microsoft YaHei-Light;
            font-weight: 400;
            color: #b4251e;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 28px;
              height: 10px;
              margin-left: 8px;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 992px) {
  #parallelSessions {
    display: block;
    width: 100%;
    padding-top: 143px;
    padding-bottom: 0px;
    .top {
      width: 100%;
    }
    .content {
      width: 90%;
      margin-left: 5%;
      height: 850px;
      margin-top: 22px;
      padding: 70px 52px 0 54px;
      background: rgba(255, 255, 255, 0.3);
      border: 2px solid;
      border-image: linear-gradient(
          160deg,
          rgba(255, 255, 255, 1),
          rgba(235, 235, 235, 0),
          rgba(235, 235, 235, 0),
          rgba(255, 255, 255, 0.62)
        )
        2 2;
      background-image: url("../assets/images/parallelSessions/bg-wap.png");
      background-repeat: no-repeat;
      background-position: right bottom;
      background-size: 680px 426px;
      .second_title {
        font-size: 30px;
        font-family: Microsoft YaHei-Light;
        font-weight: 600;
        color: #151e26;
        line-height: 45px;
      }
      .desc {
        font-size: 24px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;
        color: #151e26;
        text-align: justify;
        word-break: break-all;
        text-justify: distribute;
        margin-top: 20px;
        line-height: 43px;
      }
      .more-box {
        // height: 60px;
        margin-top: 30px;
        //border: 1px solid #b4251e;
        .more {
          height: 35px;
          font-size: 24px;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;
          display: flex;
          align-items: center;

          color: #b4251e;
          line-height: 35px;
          img {
            width: 41px;
            height: 16px;
            margin-left: 20px;
          }
        }
      }
    }
  }
}
</style>
